module.exports = __webpack_public_path__ + "media/images/default/pages/treatment_features/introduces/09-9da62c96b969e63be2e31d6138400622.jpg";